//用于管理product模块的小仓库
import { defineStore } from "pinia"; //引入创建pinia的方法

// import { reqGetProductList1, reqGetProductList2, reqGetProductList3, reqGetProductList4 } from '@/api'  //引入发送请求获取数据的方法
import { reqGetProductList1 } from "@/api"; //引入发送请求获取数据的方法

export const useProductStore = defineStore("product", {
  //state：仓库存储数据的地方
  state: () => ({
    productList: [], //分页一数据
  }),

  //action：处理action，可以书写自己的业务逻辑,可以直接修改state
  actions: {
    //分页一数据
    async getProductList1() {
      let result = await reqGetProductList1();
      if (result.code == 200) {
        this.productList = result.data;
      }
    },
    //分页二数据
    // async getProductList2() {
    //     let result = await reqGetProductList2()
    //     if (result.code == 200) {
    //         this.productList = result.data
    //     }
    // },
    //分页三数据
    // async getProductList3() {
    //     let result = await reqGetProductList3()
    //     if (result.code == 200) {
    //         this.productList = result.data
    //     }
    // },
    //分页三数据
    // async getProductList4() {
    //     let result = await reqGetProductList4()
    //     if (result.code == 200) {
    //         this.productList = result.data
    //     }
    // },
  },

  //getters：可以理解为计算属性，用于简化仓库属性。让组件获取仓库数据更便捷
  getters: {},
});
